/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "@/utils/bindUrl";
import { api } from "../api/httpClient";
import {
    ICategoryEquipment,
    ICategoryEquipmentPayload,
    IResponseListCategoryEquipments,
    IResponseShowCategoryEquipment,
    ICustomFieldPayload,
} from "@/interfaces/equipmentCategories";
import { IListParams } from "@/interfaces/serviceInterface";
import qs from "qs";

const BASE = "/category_equipments";
const BASE_CUSTOM_FIELDS = "/custom_fields";

const serialize = (p: any) =>
    qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listCategoryEquipments({
    filter,
    includes,
    page,
    limit,
    select,
    sort
}: IListParams) {
    const { data } = await api.get<IResponseListCategoryEquipments>(BASE, {
        params: { filter, includes, page, limit, select, sort },
        paramsSerializer: (params) => serialize(params),
    });
    return data;
}

export async function showCategoryEquipment({
    id,
    includes,
}: {
    id: string | number;
    includes?: string[];
}) {
    const url = buildUrl(`${BASE}/{id}`, { id });
    const { data } = await api.get<IResponseShowCategoryEquipment>(url, {
        params: { includes },
        paramsSerializer: (params) => serialize(params),
    });
    return data;
}

export async function createCategoryEquipment({ categoryEquipment }: { categoryEquipment: ICategoryEquipment }) {
    const payload: ICategoryEquipmentPayload = {
        name: categoryEquipment.name,
        isActive: categoryEquipment.isActive,
    };
    const { data } = await api.post<IResponseShowCategoryEquipment>(BASE, { categoryEquipment: payload });
    return data;
}

export async function updateCategoryEquipment({
    id,
    categoryEquipment,
}: {
    id: string | number;
    categoryEquipment: any;
}) {
    const payload: any = {
        name: categoryEquipment.name,
        isActive: categoryEquipment.isActive,
        idCustomFields: categoryEquipment.idCustomFields, // <-- ISSO AQUI SALVA A ORDEM NOVA!
    };
    const url = buildUrl(`${BASE}/{id}`, { id });
    const { data } = await api.put<IResponseShowCategoryEquipment>(url, { categoryEquipment: payload });
    return data;
}

export async function addCustomFieldToCategory({
    id,
    customField,
}: {
    id: string | number;
    customField: ICustomFieldPayload;
}) {
    const url = buildUrl(`${BASE}/{id}${BASE_CUSTOM_FIELDS}`, { id });
    const { data } = await api.put(url, { customField });
    return data;
}

// CORREÇÃO CRÍTICA AQUI: Aceita e repassa type e options para a API
export async function updateCustomField({
    categoryId,
    customFieldId,
    name,
    type,
    options,
}: {
    categoryId: string | number;
    customFieldId: string | number;
    name: string;
    type: string;
    options?: string[];
}) {
    const url = buildUrl(`${BASE_CUSTOM_FIELDS}/{customFieldId}`, { categoryId, customFieldId });
    const { data } = await api.put(url, { customField: { name, type, options } });
    return data;
}

export async function deleteCustomFieldToCategory({
    id,
    customFieldId,
}: {
    id: string | number;
    customFieldId: string | number;
}) {
    const url = buildUrl(`${BASE}/{id}${BASE_CUSTOM_FIELDS}/{customFieldId}`, { id, customFieldId });
    const { data } = await api.delete(url);
    return data;
}